module.exports = __webpack_public_path__ + "static/img/1.5f7fe23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/ltsj/1.png
// module id = NicA
// module chunks = 1